import { HTMLProps } from "react";

import { useFunnelContext } from "shared/Funnel/FunnelContextProvider";
import { useProductPageContext } from "shared/product/ProductPageContext/useProductPageContext";
import { Button } from "ui/Button";
import { usePriceAdvantage } from "utils/usePriceAdvantage";
import { useI18n } from "utils/with-i18n.utils";

type ProductOrderButtonProps = {
  className?: HTMLProps<HTMLDivElement>["className"];
  handleCreateNewOrder: () => void;
  handleWarnMe: () => void;
  isCreatingOrder: boolean;
  subscriptionSku: string | null | undefined;
};

export const ProductOrderButton = ({
  className,
  handleCreateNewOrder,
  handleWarnMe,
  isCreatingOrder,
  subscriptionSku,
}: ProductOrderButtonProps) => {
  const i18n = useI18n();
  const { currentVariant } = useProductPageContext();
  const { isSwap } = useFunnelContext();

  const priceAdvantage = usePriceAdvantage({
    originalUpfrontPrice: currentVariant?.originalUpfrontPrice,
    upfrontPrice: currentVariant?.upfrontPrice,
  });

  const { discountInfo } = priceAdvantage;

  return (
    <>
      {currentVariant?.isInStock ? (
        <Button
          className={className}
          onClick={handleCreateNewOrder}
          isLoading={isCreatingOrder}
          disabled={!subscriptionSku || (isSwap && !discountInfo)}
        >
          {i18n.t("product.available.iOrder")}
        </Button>
      ) : (
        <Button className={className} onClick={handleWarnMe}>
          {i18n.t("product.outOtStock.warnMe")}
        </Button>
      )}
    </>
  );
};
